import React from 'react';
import { HStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { Maybe } from '@springbig/shared/src/services/dutchie/schema-types';
import { useTheme } from '@springbig/shared';

export type PriceTagProps = {
    price: Maybe<number> | undefined;
    discountedPrice?: Maybe<number> | undefined;
    fontSize?: number;
};

export const PriceTag = ({
    price,
    discountedPrice,
    fontSize = 14,
}: PriceTagProps) => {

    const {
        highlight_text,
    } = useTheme();

    return (
        <HStack space={1} alignItems={'baseline'} alignSelf={'flex-end'}>
            { !discountedPrice &&
                <Caption
                    fontSize={fontSize}
                    fontWeight={'bold'}
                    color={highlight_text}
                >
                    ${ price }
                </Caption>
            }
            { discountedPrice &&
                <Caption
                    fontSize={fontSize}
                    fontWeight={'bold'}
                    color={highlight_text}
                >
                    ${ discountedPrice }
                </Caption>
            }
        </HStack>
    );
};
